/**
 * @generated SignedSource<<3d3030f58bbb93be92cdadfa833bd0f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarknotificationviewedPayload",
    "kind": "LinkedField",
    "name": "marknotificationviewed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkNotificationViewedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkNotificationViewedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ba53b43a648b7d10ee3c63a1ce7a18f4",
    "id": null,
    "metadata": {},
    "name": "MarkNotificationViewedMutation",
    "operationKind": "mutation",
    "text": "mutation MarkNotificationViewedMutation(\n  $input: MarknotificationviewedInput!\n) {\n  marknotificationviewed(input: $input) {\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "f389e1638968403e3d69aeea8279e4ee";

module.exports = node;
